import React from 'react';
import './Manufacturingprose.css';
import Manufactur from '../../../imgs/Manufacturin.webp';

const Manufacturingprose = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">The Common Types of Plastic Pallet Manufacturing Process</h2>
                <p className="Material-date">Dec. 16, 2022</p>
                <div className="Manufactur">
                    <img src={Manufactur} alt="72 Cavity PET Preforms Machine" className="Manufactur-image" />
                </div>
                <p className="Material-text">There are many techniques on the market that exist today to
                     manufacture plastic pallets. The common plastic pallet manufacturing processes: 
                    injection, thermoforming, blowing, and compression.</p>
            </div>
        </div>
    );
};
export default Manufacturingprose;
